<script setup lang="ts">
import { PageUrl } from '~/types'
import Page from '~/components/Layout/Page.vue'

definePageMeta({
  layout: 'page',
})

const { page } = storeToRefs(usePageStore())
const { loadPage, setCurrentUrl } = usePageStore()

// await diretto su loadPage, non avvolto in useAsyncData (vedi [...all].vue per il dettaglio)
await loadPage(PageUrl.ACCESSIBILITY)

onBeforeMount(() => setCurrentUrl(PageUrl.ACCESSIBILITY))
</script>

<template>
  <Page v-if="page" title="Dichiarazione di Accessibilità" :page="page" />
</template>
